import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTrending2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconTrending2"><Path d="M2.75 10.9637L3.77565 13.3982C4.13443 14.2498 5.35257 14.2028 5.645 13.3259L6.90991 9.53333C7.2176 8.6108 8.5221 8.62319 8.81233 9.5514L11.9377 19.5469C12.242 20.5202 13.6313 20.47 13.865 19.4771L17.3856 4.5229C17.6149 3.54875 18.9682 3.47495 19.3014 4.41841L21.25 9.93646" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconTrending2;
